module.exports = __webpack_public_path__ + "fonts/Vazir-Bold.270d17fe.eot";